import { Box, Typography } from '@mui/material';
import { useNumberFormatter } from '@guest-widgets/shared/src/hooks/useNumberFormatter';
import { styled } from '@guest-widgets/core';

import { useUpsellInSelection } from '../upsellInSelectionContext';
import { useUpsell } from '../../contexts/upsellContext/upsellContext';
import ItemDeleteDialog from '../../common/ItemDeleteDialog';
import { ChipInfo } from '../../common/ChipInfo';

import { ImageWithFallback } from './ImageWithFallback';
import { SimpleQty } from './SimpleQty';
import { useInnerDrawer } from './useInnerDrawer';
import { TimeQty } from './TimeQty';
import { Navigation } from './Navigation';

export const SimpleLayout = () => {
  const { hasError } = useUpsell();
  const { upsellInModal, addToCartErrors, isUpsellInCart } = useUpsellInSelection();
  const {
    rateLimitError,
    addToCart,
    onOpenRemoveDialog,
    removeFromCart,
    openRemoveDialog,
    onCloseRemoveDialog,
  } = useInnerDrawer();
  const {
    price,
    images,
    name,
    currency,
    companyInformation,
    information,
    totalQuantity,
    configuration,
  } = upsellInModal;
  const { formatPrice } = useNumberFormatter(companyInformation?.locale?.language);

  if (!Object.values(upsellInModal).length) return null;

  const { sameParentQuantity, uiSelectors, isRequired } = configuration;
  const { body } = information?.description || {};
  const itemPrice = price !== undefined ? formatPrice(price, currency) : '';
  const { isInCart, hasChanged } = isUpsellInCart(upsellInModal);
  const disableAddToCart =
    hasError || !totalQuantity || (sameParentQuantity && isInCart && !hasChanged);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Box mb={4} mt={-10}>
          <ImageWithFallback src={images?.[0]?.url ?? ''} alt={images?.[0]?.alt} />
        </Box>
        <Typography variant="h3" pb={sameParentQuantity ? 2 : 4}>
          {name}
        </Typography>
        <ChipInfo isInherited={sameParentQuantity} isRequired={isRequired} />
        {body && <Description variant="body1" pb={4} dangerouslySetInnerHTML={{ __html: body }} />}
        {uiSelectors.drawerLayout === 'singleQty' && !sameParentQuantity ? (
          <SimpleQty item={upsellInModal} itemPrice={itemPrice} />
        ) : (
          <TimeQty item={upsellInModal} />
        )}
      </Box>
      <Navigation
        parentErrors={addToCartErrors}
        disabled={disableAddToCart}
        rateLimitError={rateLimitError}
        showRemoveButton={isInCart}
        onAddToCart={addToCart}
        onRemoveFromCart={onOpenRemoveDialog}
      />
      <ItemDeleteDialog
        open={openRemoveDialog}
        onClose={onCloseRemoveDialog}
        onConfirm={removeFromCart}
        productName={upsellInModal.name}
        rateLimitError={rateLimitError}
      />
    </>
  );
};

const Description = styled(Typography)({
  '& p': {
    marginBlockStart: 'unset',
    marginBlockEnd: 'unset',
  },
});
